import React from 'react';
import { motion } from 'framer-motion';
import { Check, Minus } from 'lucide-react';
const features = [{
  name: '¿Quién atiende los contactos?',
  start: 'Tú',
  base: 'Tú',
  pro: 'Nosotros'
}, {
  name: 'Curso online',
  start: true,
  base: true,
  pro: true
}, {
  name: 'Asesoría inicial',
  start: true,
  base: true,
  pro: true
}, {
  name: 'Guías y checklist',
  start: true,
  base: true,
  pro: true
}, {
  name: 'Revisión de publicación',
  start: false,
  base: true,
  pro: true
}, {
  name: 'Publicación en Portal Inmobiliario',
  start: false,
  base: true,
  pro: true
}, {
  name: 'Publicación destacada',
  start: false,
  base: false,
  pro: true
}, {
  name: 'CRM para contactos',
  start: false,
  base: true,
  pro: true
}, {
  name: 'Sesión de seguimiento',
  start: false,
  base: true,
  pro: true
}, {
  name: 'Fotos profesionales',
  start: false,
  base: false,
  pro: true
}, {
  name: 'Plano de propiedad',
  start: false,
  base: false,
  pro: true
}, {
  name: 'Atención de leads',
  start: false,
  base: false,
  pro: true
}, {
  name: 'Filtrado de compradores',
  start: false,
  base: false,
  pro: true
}, {
  name: 'Coordinación de visitas',
  start: false,
  base: false,
  pro: true
}, {
  name: 'Asesoría en oferta',
  start: false,
  base: false,
  pro: true
}, {
  name: 'Apoyo en promesa y notaría',
  start: false,
  base: false,
  pro: true
}];
function CellValue({
  value
}: {
  value: boolean | string;
}) {
  if (typeof value === 'string') {
    return <span className="text-sm font-semibold" data-id="element-6">{value}</span>;
  }
  return value ? <Check className="text-brand-600" size={18} data-id="element-7" /> : <Minus className="text-gray-300" size={16} data-id="element-8" />;
}
export function ComparisonTable() {
  return <section className="py-24 px-6 bg-white" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-12">
            Compara los planes
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="overflow-x-auto pb-6" data-id="element-13">
          <div className="min-w-[600px]" data-id="element-14">
            {/* Header */}
            <div className="grid grid-cols-4 mb-2" data-id="element-15">
              <div className="p-4" data-id="element-16"></div>
              <div className="p-4 text-center" data-id="element-17">
                <p className="text-sm font-bold text-gray-900" data-id="element-18">Start</p>
                <p className="text-xs text-gray-400" data-id="element-19">$129.900</p>
              </div>
              <div className="p-4 text-center" data-id="element-20">
                <p className="text-sm font-bold text-gray-900" data-id="element-21">Base</p>
                <p className="text-xs text-gray-400" data-id="element-22">$349.900</p>
              </div>
              <div className="p-4 text-center bg-brand-50 rounded-t-xl border-x border-t border-brand-100" data-id="element-23">
                <p className="text-sm font-bold text-brand-700" data-id="element-24">Pro</p>
                <p className="text-xs text-brand-500" data-id="element-25">$899.900</p>
              </div>
            </div>

            {/* Rows */}
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-26">
              {features.map((feature, index) => {
              const isLast = index === features.length - 1;
              return <div key={feature.name} className={`grid grid-cols-4 ${!isLast ? 'border-b border-gray-100' : ''}`} data-id="element-27">
                    <div className="px-5 py-3.5 text-sm font-medium text-gray-700 flex items-center" data-id="element-28">
                      {feature.name}
                    </div>
                    <div className="px-5 py-3.5 flex items-center justify-center text-gray-600" data-id="element-29">
                      <CellValue value={feature.start} data-id="element-30" />
                    </div>
                    <div className="px-5 py-3.5 flex items-center justify-center text-gray-600" data-id="element-31">
                      <CellValue value={feature.base} data-id="element-32" />
                    </div>
                    <div className="px-5 py-3.5 flex items-center justify-center bg-brand-50/40 border-x border-brand-100 text-brand-700" data-id="element-33">
                      <CellValue value={feature.pro} data-id="element-34" />
                    </div>
                  </div>;
            })}
            </div>

            {/* Bottom CTA row */}
            <div className="grid grid-cols-4 mt-4" data-id="element-35">
              <div className="p-4" data-id="element-36"></div>
              <div className="p-4 flex justify-center" data-id="element-37">
                <button className="text-xs font-medium text-gray-500 hover:text-gray-700 transition-colors" data-id="element-38">
                  Elegir Start
                </button>
              </div>
              <div className="p-4 flex justify-center" data-id="element-39">
                <button className="text-xs font-medium text-brand-600 hover:text-brand-700 transition-colors" data-id="element-40">
                  Elegir Base
                </button>
              </div>
              <div className="p-4 flex justify-center bg-brand-50 rounded-b-xl border-x border-b border-brand-100" data-id="element-41">
                <button className="text-xs font-bold text-brand-700 hover:text-brand-800 transition-colors" data-id="element-42">
                  Elegir Pro →
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}